export enum ComponentId {
  INCIDENT_STATEMENTS_TYPE = "type",
  INCIDENT_STATEMENTS_POLICE_DEPARTMENT = "policeDepartment",
  INCIDENT_STATEMENTS_CASE_NUMBER = "caseNumber",
  INCIDENT_STATEMENTS_POLICE_IMAGES = "ocVehiclePolice",
  INCIDENT_STATEMENTS_PERPETRATOR_IMAGES = "ocVehiclePerpetrator",
}
